import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./styles.css";
import "./themes.css";
import "./layout.css";   // the grid, the shell and the fluid type (design system 1.0, phase 3)
import "./styles/pages-sell.css";
import "./styles/pages-calliq.css";
import "./styles/pages-companyiq.css";
import "./styles/pages-manage.css";
import "./skins.css";
import { applyTheme, storedTheme } from "./theme.js";
import { applyScale, storedScale } from "./scale.js";
import { applyKit, storedKit } from "./skins.js";

// Paint the saved theme before first render so the login page / reload never flash the wrong one.
applyTheme(storedTheme());
applyScale(storedScale());
// Same for the chosen menu background (Salem 2026-08-27) — no flash of the plain navy first.
applyKit(storedKit());

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// "In their pocket" (October 2026): the service worker that shows push notifications and opens
// the app when one is tapped. It caches nothing, so registering it can never serve a stale build.
// Registered after load so it never competes with the first paint.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => { /* push simply stays off */ });
  });
}
